<template>
    <section class="story-wrap" ref="story-wrap">
        <transition name="story">
            <div class="story-cover" v-show="initShow" @mousemove="mouseMoveHandler">
                <div class="story-itme" :class="[`story-item--${item.name}`, stroySelectedIndex === index ? 'active' : (stroySelectedIndex !== -1 ? 'inactive' : '')]" v-for="(item, index) in storyList" :key="`story-item-${index}`">
                    <div class="story-item-inner">
                        <div class="story-image-container" :style="parallaxStyle">
                            <div class="story-tip" :class="{ 'story-tip--focus': storyImageFocusIndex === index }">
                                <p class="story-tip--jp">{{ item.title.jp }}</p>
                                <p class="story-tip--en">{{ item.title.en }}</p>
                            </div>
                            <div class="story-image-wrapper" :style="parallaxStyle" :class="{ 'story-image-wrapper--focus': storyImageFocusIndex === index }">
                                <img :src="item.sotryImg" class="story-image" alt="">
                            </div>
                            <a href="javascript: void(0);" v-show="stroySelectedIndex === -1" class="story-image-mask" @mouseenter="maskMouseEnter(index)" @mouseleave="maskMouseLeave" @click="showDetail(index)"></a>
                        </div>
                        <div class="story-detail">
                            <i class="iconfont iconguanbi1 story-detail-close" @click="hideDetail"></i>
                            <div class="story-detail-title">
                                <p class="story-tip--jp">{{ item.title.jp }}</p>
                                <p class="story-tip--en">{{ item.title.en }}</p>
                            </div>
                            <div class="story-detail-text">{{ item.detail.text }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </section>
</template>

<script>
export default {
    name: "Story",

    components: {

    },
    data: () => ({
        storyList: [
            {
                name: "origin",
                title: {
                    jp: "",
                    en: "Originiums",
                },
                sotryImg: require("../../assets/images/story/item_origin.png"),
                detail: {
                    text: "As the world was torn apart by Catastrophes of unknown origin, Originium ore began to appear. With advances in technology, the power of the ore was harnessed to push civilization forward. But Originium ore also gave birth to the Infected..."
                }
            },
            {
                name: "infected",
                title: {
                    jp: "",
                    en: "Infected",
                },
                sotryImg: require("../../assets/images/story/item_infected.png"),
                detail: {
                    text: 'Those infected by Originium Ore. The fatality rate of Oripathy is theoretically 100%. The threat of contagion remains upon the carrier’s death. Combined with the threat of dangerous, unknown powers, most countries have chosen to expel the Infected. Left stateless, the Infected had no clear path to life. But recently, the Infected have begun to gather around the radical resistance movement known as "Reunion."'
                }
            },
            {
                name: "reunion",
                title: {
                    jp: "",
                    en: "Reunion",
                },
                sotryImg: require("../../assets/images/story/item_reunion.png"),
                detail: {
                    text: 'A radical Infected organization, Reunion rallies around the cause of Infected nationalism, rejecting racial and national identities. They aggressively push for acquisition and exploitation of Infected power. Reunion uses violence in their push for justice, having gone so far as to destroy an entire city. This led to the intervention of a pharmaceutical company called "Rhodes Island," the outcome of which is not yet clear.'
                }
            },
            {
                name: "rhodes",
                title: {
                    jp: "",
                    en: "Rhodes Island",
                },
                sotryImg: require("../../assets/images/story/item_rhodes.png"),
                detail: {
                    text: "The most advanced Infected research institution in the world, Rhodes Island is not afraid to employ the Infected. They are known to go deep into hazardous areas to take care of issues related to the Infected. They are currently working with many governments, corporations, and NGOs to uncover the causes of an Infected riot on an unprecedented scale. Your decisions will have a significant impact on how Rhodes Island will proceed."
                }
            },
            {
                name: "mortal",
                title: {
                    jp: "",
                    en: "Nomadic City",
                },
                sotryImg: require("../../assets/images/story/item_mortal_city.png"),
                detail: {
                    text: "These cities are built on special structures and can be moved. The threat of Catastrophe meant that every nation would need to be constantly on the move to avoid disaster, giving rise to this technology. The structures continued to expand as engineers developed new ways to add buildings and facilities to them, eventually becoming sprawling, mobile cities."
                }
            },
            {
                name: "crafts",
                title: {
                    jp: "",
                    en: "Originium Arts",
                },
                sotryImg: require("../../assets/images/story/item_art_crafts.png"),
                detail: {
                    text: 'After the discovery of Originium ore, people mastered a technique for the manipulation and transformation of matter using the power of the ore. The technique came to be called Originium Arts, and often simply "Arts." Whether a person can use Arts, and what forms those Arts may take is determined by both physiology and study in the field of Originium Arts.'
                }
            },
        ],
        storyImageFocusIndex: -1,     // 图片缩放标识
        stroySelectedIndex: -1,       // 图片选中标识
        initShow: false,              // 第一次进入该板块标识
        parallax_pos: {               // 视差偏移值
            x: 0,
            y: 0
        },
        mouse_pos: {                  // 鼠标屏幕移动坐标
            x: 0,
            y: 0
        }
    }),
    created() {
        
    },
    mounted() {
    },
    watch: {
        NAV_ACTIVE_INDEX(val) {
            if(val === 4) {
                this.initShow = true
                this.animateImage()     // 开启动画
            }
        }
    },
    computed: {
        NAV_ACTIVE_INDEX() {
            return this.$store.getters.NAV_ACTIVE_INDEX
        },
        parallaxStyle() {       // 鼠标滑动时，视差样式
            return `transform: translate(${this.parallax_pos.x}%, ${this.parallax_pos.y}%);`
        }
    },
    methods: {
        maskMouseEnter(index) {
            this.storyImageFocusIndex = index
        },
        maskMouseLeave() {
            this.storyImageFocusIndex = -1
        },
        showDetail(index) {
            this.stroySelectedIndex = index
        },
        hideDetail() {
            this.stroySelectedIndex = -1
            this.animateImage()
        },
        getStep(delValue, minValue) {
            if(Math.abs(delValue) - minValue < 0) {
                return delValue
            }
            let stepValue = Math.abs(delValue / 20)
            stepValue = (stepValue - minValue) > 0 ? stepValue : minValue
            return delValue > 0 ? stepValue : (stepValue * -1)
        },
        mouseMoveHandler(event) {
            let boxW = this.$refs['story-wrap'].clientWidth
            let boxH = this.$refs['story-wrap'].clientHeight
            
            this.mouse_pos.x = (event.clientX / boxW - 0.5) * 5
            this.mouse_pos.y = (event.clientY / boxH - 0.5) * 5
        },
        animateImage() {
            this.parallax_pos.x = this.parallax_pos.x + this.getStep(this.mouse_pos.x - this.parallax_pos.x, 0.001)
            this.parallax_pos.y = this.parallax_pos.y + this.getStep(this.mouse_pos.y - this.parallax_pos.y, 0.001)

            if(this.NAV_ACTIVE_INDEX === 4 && this.stroySelectedIndex === -1) {       // 离开停止
                window.requestAnimationFrame(this.animateImage);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.story-wrap {
    background: url("../../assets/images/story/bg.jpg") no-repeat;
    background-size: cover;

    .story-cover {
        position: relative;
        width: 100%;
        height: 100%;

        .story-itme {
            position: absolute;
            transition: all ease-in-out .3s;

            .story-item-inner {
                position: absolute;
                width: 80%;
                height: 80%;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                // background: rgb(153, 153, 153);

                .story-image-container {
                    position: absolute;
                    width: 50%;
                    height: 0;
                    padding-top: 50%;

                    &::before {
                        content: "";
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: url("../../assets/images/story/item_shadow.png") no-repeat;
                        background-size: 100% 100%;
                        transition: all ease-in-out .3s;
                    }

                    .story-tip {
                        position: absolute;
                        left: 22.5%;
                        width: 0;
                        transition: all ease-in-out .3s;
                        overflow: hidden;
                        opacity: .5;
                        font-size: 0;

                        .story-tip--jp {
                            font-family: "rohonminsink";
                            font-size: pxTorem(24px);
                            line-height: 1;
                            white-space: nowrap;
                        }
                        .story-tip--en {
                            font-family: "rohonminsink";
                            font-size: pxTorem(24px);
                            line-height: 1.5;
                            white-space: nowrap;
                        }

                        &.story-tip--focus {
                            width: 100%;
                            opacity: 1;
                        }
                    }

                    .story-image-wrapper {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        // background: lightskyblue;

                        .story-image {
                            transition: transform ease-in-out .3s;
                            width: 100%;
                            height: 100%;
                        }

                        &.story-image-wrapper--focus {
                            .story-image {
                                transform: scale(1.1);
                            }
                        }
                    }
                    .story-image-mask {
                        display: block;
                        position: absolute;
                        left: 25%;
                        right: 25%;
                        top: 0;
                        bottom: 0;
                        cursor: pointer;
                        background: transparent;
                        // background: #d8674583;
                    }
                }
                .story-detail {
                    opacity: 0;
                    position: relative;
                    top: 50%;
                    transform: translateY(-50%);
                    margin: 0 18% 0 46%;

                    .story-detail-close {
                        position: absolute;
                        color: #000;
                        transform-origin: left center;
                        right: pxTorem(-5px);
                        bottom: 100%;
                        font-size: pxTorem(32px);
                        cursor: pointer;
                    }

                    .story-detail-title {
                        transform-origin: center bottom;
                        transform: scaleY(0);
                        font-size: 0;
                        
                        .story-tip--jp {
                            font-family: "rohonminsink";
                            font-size: pxTorem(55px);
                            line-height: 1;
                            white-space: nowrap;
                        }
                        .story-tip--en {
                            font-family: "rohonminsink";
                            font-size: pxTorem(30px);
                            line-height: 1.5;
                            white-space: nowrap;
                        }
                    }
                    .story-detail-text {
                        transform-origin: center bottom;
                        transform: scaleY(0);
                        font-family: 'SourceHanSansSubset', sans-serif;
                        font-size: pxTorem(16px);
                        color: #010101;
                        border-top: 1px solid #000;
                        padding-top: pxTorem(22px);
                        margin-top: pxTorem(28px);
                        line-height: 1.5;
                    }
                }
            }
            
            &.story-item--origin {
                width: 80%;
                height: 80%;
                left: -5%;
                top: 5%;
                // background: lightgoldenrodyellow;
                z-index: 1;

                .story-image-container::before {
                    top: 0;
                    left: 0;
                } 
                .story-tip {
                    top: 77.5%;
                }
            }
            &.story-item--infected {
                left: 47%;
                top: 40%;
                width: 40%;
                height: 40%;
                z-index: 3;
                transition-delay: 25ms;
                // background: lightgray;

                .story-image-container::before {
                    top: 15%;
                    left: 5%;
                } 
                .story-tip {
                    top: 92.5%;
                }
            }
            &.story-item--reunion {
                left: 35%;
                top: 0;
                width: 40%;
                height: 40%;
                transition-delay: 50ms;
                // background: lightgreen;
                z-index: 4;

                .story-image-container::before {
                    top: 20%;
                    left: 0;
                } 
                .story-tip {
                    top: 97.5%;
                }
            }
            &.story-item--rhodes {
                left: 68%;
                top: 40%;
                width: 60%;
                height: 60%;
                z-index: 4;
                transition-delay: 75ms;
                // background: lightpink;

                .story-image-container::before {
                    top: 0;
                    left: 0;
                } 
                .story-tip {
                    top: 75.5%;
                    left: 15% !important;
                }
            }
            &.story-item--mortal {
                left: 60%;
                top: -5%;
                width: 50%;
                height: 50%;
                z-index: 5;
                transition-delay: .1s;
                // background: lightskyblue;

                .story-image-container {
                    transition: margin ease-in-out .3s;
                }

                .story-image-container::before {
                    top: 20%;
                    left: 0;
                } 
                .story-tip {
                    top: 97.5%;
                }
            }
            &.story-item--crafts {
                left: 25%;
                top: 46%;
                width: 50%;
                height: 50%;
                transition-delay: 125ms;
                // background: lightseagreen;      
                z-index: 2;

                .story-image-container::before {
                    top: 10%;
                    left: 0;
                } 
                .story-tip {
                    top: 95%;
                }
            }

            // active
            &.active {
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                opacity: 1;
                z-index: 99;

                &.story-item--mortal {
                    .story-image-container {
                        margin-top: -5%;
                        margin-left: -3%;
                    }
                }

                .story-detail {
                    transition: all ease-in-out .3s .3s;
                    opacity: 1;

                    .story-detail-title {
                        transform: none;
                        opacity: 1;
                        transition: all ease-in-out .3s .3s;
                    }
                    .story-detail-text {
                        transition: all ease-in-out .3s .3s;
                        transform: none;
                        opacity: 1;
                    }
                }
            }
            // inactive
            &.inactive {
                opacity: 0;
                transform: translateY(-100%);
            }
        }
    }

    .story-enter-active, .story-leave-active {
        transition: all ease-in-out .6s .5s;
    }
    .story-enter, .story-leave-to {
        opacity: 0;
        transform: translateY(-20%);
    }
}
</style>
